<template>
	<div class="report-incident">
		<Modal :show="showReportIncident">
			<template #content>
				<div class="p-6 md:p-8 max-w-2xl mx-auto">
					<!-- Header -->
					<h1
						class="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-8"
					>
						Report an Incident
					</h1>
					<div
						class="close-modal f-r"
						@click="$store.commit('showReportIncident', false)"
					>
						<i class="fa fa-times"></i>
					</div>

					<!-- Form Content -->
					<form @submit.prevent="handleSubmit" class="space-y-6">
						<!-- Incident Date -->
						<div>
							<label
								for="incident-date"
								class="block text-sm font-medium text-gray-700 mb-2"
							>
								Incident Date
								<span class="text-red-500">*</span>
							</label>
							<input
								id="incident-date"
								type="date"
								v-model="form.incidentDate"
								required
								class="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150"
							/>
						</div>

						<!-- Remarks -->
						<div>
							<label
								for="remarks"
								class="block text-sm font-medium text-gray-700 mb-2"
							>
								Remarks / Description
								<span class="text-red-500">*</span>
							</label>
							<textarea
								id="remarks"
								v-model="form.remarks"
								rows="5"
								required
								placeholder="Please describe the incident in detail..."
								class="w-full px-4 py-3 border border-gray-700 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 resize-y"
							></textarea>
						</div>

						<!-- Action Buttons -->
						<div class="flex flex-col sm:flex-row gap-4 mt-8">
							<button
								type="button"
								@click="closeModal"
								class="flex-1 py-3 px-6 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded-lg transition duration-150"
							>
								Cancel
							</button>

							<button
								type="submit"
								class="flex-1 py-3 px-6 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg shadow-md transition duration-150 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
							>
								Submit Report
							</button>
						</div>
					</form>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
export default {
	components: {
		Modal: () => import('@/components/newportal/templates/others/modal'),
	},

	data() {
		return {
			form: {
				incidentDate: '',
				remarks: '',
			},
		};
	},

	computed: {
		...mapGetters(['showReportIncident']),
	},

	methods: {
		closeModal() {
			this.$store.commit('showReportIncident', false);
		},

		handleSubmit() {
			// Add your submission logic here
			console.log('Submitting incident:', this.form);

			// Example:
			// this.$store.dispatch('submitIncidentReport', this.form)
			//   .then(() => this.closeModal())

			alert('Incident report submitted!'); // temporary
			this.closeModal();
		},
	},
};
</script>

<style scoped>
/* Optional: Extra polish if needed */
.report-incident :deep(.modal-content) {
	border-radius: 1rem;
	box-shadow:
		0 20px 25px -5px rgb(0 0 0 / 0.1),
		0 8px 10px -6px rgb(0 0 0 / 0.1);
}
</style>
